import { z } from 'zod';
const userEntitySchema = z.object({
    id: z.number(),
    email: z.email(),
    fullName: z.string().min(1),
    countryAlpha2: z.string().length(2),
    companyName: z.string(),
    externalId: z.string().optional()
});
const userEntityToCreateSchema = userEntitySchema.omit({ id: true });
export { userEntitySchema, userEntityToCreateSchema };
//# sourceMappingURL=projects.user.model.js.map